import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { AcumaticaService } from './../acumatica/acumatica.service';
import { Injectable } from '@angular/core';
import { AlertDialog } from '../common/alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class MayerFabricsService {

  constructor(
    private acumatica: AcumaticaService,
    private dialog: MatDialog,
  ) { }

  /**
   * Return the life cycle converting Orange to Green when in Sales-Rep mode
   */
  static LifeCycle = (LifeCycle: string | null): string | null => !LifeCycle ? null : ((environment.mode == 'rep' == true && LifeCycle.substring(0, 1).toUpperCase() == 'O') ? 'Green' : LifeCycle);
  /**
   * Return the life cycle converting Orange to Green when in Sales-Rep mode
   */
  LifeCycle = MayerFabricsService.LifeCycle;

  /**
   * Return the single-letter Life Cycle (G,Y,O,R,B) code for the given Life Cycle
   */
  static LifeCycleCode(LifeCycle: string | null): string | null {
    LifeCycle = this.LifeCycle(LifeCycle);
    return !LifeCycle ? null : LifeCycle!.substring(0, 1).toUpperCase();
  }
  /**
   * Return the single-letter Life Cycle (G,Y,O,R,B) code for the given Life Cycle
   */
  LifeCycleCode = MayerFabricsService.LifeCycleCode;

  /**
   * Return an rgba(..) CSS value representing the Life Cycle code
   */
  LifeCycleColor(LifeCycle: string | null): string {
    LifeCycle = MayerFabricsService.LifeCycleCode(LifeCycle);

    switch (LifeCycle) {
      case 'G':
        return 'rgba(112, 173, 71, 0.9)';
      case 'Y':
        return 'rgba(255, 255, 0, 0.9)';
      case 'O':
        return 'rgba(255, 140, 0, 0.9)';
      case 'R':
        return 'rgba(255, 0, 0, 0.9)';
      case 'B':
        return 'rgba(128, 0, 128, 0.9)';
      default:
        return 'inherited';
    }
  }

  /**
   * Return a contrasting CSS color to the given Life Cycle color (Black for Yellow; White otherwise)
   */
  LifeCycleContrastColor(LifeCycle: string | null) {
    LifeCycle = MayerFabricsService.LifeCycleCode(LifeCycle);
    switch ((LifeCycle || '').toUpperCase()) {
      case 'Y':
        return 'black';

      default:
        return 'white';
    }
  }

  get RepWarehouseID(): string | null {
    let overrideWhseID = localStorage.getItem('OverrideRepWhseID');
    if (overrideWhseID) return overrideWhseID;

    if (this.acumatica.username == null) return null; // logged out
    return this.acumatica.RepWarehouseID;
  }

  get RepCustomerID(): string | null {
    if (this.acumatica.username == null) return null; // logged out
    return this.acumatica.RepCustomerID;
  }
}
